import { render, staticRenderFns } from "./PurchasingPricing.vue?vue&type=template&id=6373ba1a&"
import script from "./PurchasingPricing.vue?vue&type=script&lang=js&"
export * from "./PurchasingPricing.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingPricing.vue?vue&type=style&index=0&id=6373ba1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports